export const FETCHING_IP_INFO = 'FETCHING_IP_INFO'
export const RECEIVED_IP_INFO = 'RECEIVED_IP_INFO'
export const ERROR_FETCHING_IP_INFO = 'ERROR_FETCHING_IP_INFO'
